<div class="breadcrumb">
  <a [routerLink]="home.url">{{home.titulo}}</a>
  <a *ngFor="let link of links" [routerLink]="link.url">{{link.titulo}}</a>
  <span *ngIf="tituloPagina"><strong>{{tituloPagina}}</strong></span>
</div>
